import _slicedToArray from "/tmp/builds/6a0385be-2073-47eb-9a95-834a2b68b101-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.from-entries.js";

/* eslint-disable @typescript-eslint/no-explicit-any */
export var objectFromEntries = !Object.fromEntries ? function (entries) {
  if (!entries || !entries[Symbol.iterator]) {
    throw new Error("Object.fromEntries() requires a single iterable argument");
  }

  var o = {};
  Object.keys(entries).forEach(function (key) {
    var _entries$key = _slicedToArray(entries[key], 2),
        k = _entries$key[0],
        v = _entries$key[1];

    o[k] = v;
  });
  return o;
} : Object.fromEntries;